import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="popper"
export default class extends Controller {
  static targets = ["tooltip"];

  tooltipTargetConnected(target) {
    new Bootstrap.Tooltip(target);
  }
}